import { fetchBasicGetJson } from "@/script/common";

let _culturesPromise = null;
export default {
    cultures() {
        if (_culturesPromise === null) {
            _culturesPromise = new Promise(resolve =>
                fetchBasicGetJson('/Culture/GetList')
                    .then(resolve)
                    .catch(() => resolve([]))
            );
        }
        return _culturesPromise;
    }
}